import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Label, Typography } from '@pocketlaw/tetris';
import { useFormikContext } from 'formik';
import { useEsigningProviderMetadata } from 'app/domains/esigning/hooks/useEsigningProviderMetadata';
import { EsigningProviderAuthenticationModeSlug, EsigningRecipientType } from 'shared/domains/apollo/generated/types';
import { TextField } from 'shared/domains/forms';
import { PhoneNumberField } from 'shared/domains/forms/components/PhoneNumberField';
import { RoleAndAuth } from './RoleAndAuth';
import { ColumnsContainer, FieldWrapper, LeftColumn, RightColumn } from './styled';
export function Content() {
    const { values: formValues } = useFormikContext();
    const { type, authenticationMode } = formValues;
    const { properties: metadataProperties } = useEsigningProviderMetadata();
    const { canUseTitleField } = metadataProperties;
    const isSigning = type === EsigningRecipientType.Signatory;
    const isApprover = type === EsigningRecipientType.Approver;
    const showTitleField = (isSigning || isApprover) && canUseTitleField;
    const showMobileField = isSigning && authenticationMode === EsigningProviderAuthenticationModeSlug.SmsOtp;
    const optionalFieldDescription = t({
        comment: 'Signing party form field - Optional field text',
        message: 'If applicable',
    });
    return (<ColumnsContainer>
      <LeftColumn>
        <div style={{ position: 'relative' }}>
          <Label>
            <Trans comment="Label for the add/edit e-signing party details">
              Add details for signing or non-signing parties
            </Trans>
          </Label>
        </div>
        <Typography $appearance="100" $fontSize="small">
          <Trans comment="Message for the add/edit e-signing party details">
            Signing parties will be able to sign the document. Non-signing parties will receive a copy once it&apos;s
            signed. You can also select and manage contacts under the Contact library tab.
          </Trans>
        </Typography>
      </LeftColumn>
      <RightColumn>
        <FieldWrapper>
          <TextField name="firstName" label={t({
            comment: 'Signing party form field - First name',
            message: 'First name',
        })}/>
        </FieldWrapper>
        <FieldWrapper>
          <TextField name="lastName" label={t({ comment: 'Signing party form field - Last name', message: 'Last name' })}/>
        </FieldWrapper>
        <FieldWrapper>
          <TextField name="email" label={t({ comment: 'Signing party form field - Email', message: 'Email' })}/>
        </FieldWrapper>
        {showTitleField && (<FieldWrapper>
            <TextField name="title" label={t({ comment: 'Signing party form field - Title', message: 'Title' })} description={optionalFieldDescription}/>
          </FieldWrapper>)}
        <FieldWrapper>
          <TextField name="label" label={t({ comment: 'Signing party form field - Company', message: 'Company' })} description={optionalFieldDescription}/>
        </FieldWrapper>
        <RoleAndAuth />
        {showMobileField && (<PhoneNumberField stretch name="mobile" label={t({
                comment: 'Signing party form field - Phone number',
                message: 'Phone number',
            })}/>)}
      </RightColumn>
    </ColumnsContainer>);
}
